<template>
  <div>
    <div class="card shadow-sm border-0 p-4 mb-4">
      <!-- Header Title -->
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 class="fw-bold mb-0 text-primary">
          <i class="bi bi-file-earmark-bar-graph me-2"></i>
          Financial Reports
        </h5>
      </div>

      <!-- Date Filters -->
      <div class="row g-3 align-items-center">
      	<div class="col-md-4">
      		<label class="form-label fw-semibold small text-secondary mb-1">
	            <i class="bi bi-calendar3 me-1"></i>Accounts name (only for Ledger)
	         </label>
  	        <div class="position-relative">
              <!-- Search Input -->
              <input
              type="text"
              v-model="query"
              @input="debouncedSearch"
              :placeholder="$t('search_item_by_name_code')"
              class="form-control shadow-sm rounded-pill"
              @keydown="handleKeys"
            />

              <!-- Dropdown Search Results -->
              <div
                v-if="query"
                class="search-results shadow rounded bg-white position-absolute mt-2"
                style="width:450px; max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
                :class="{ 'd-block': results.length > 0, 'd-none': results.length === 0 }"
              >

              <!-- Results List -->
              <ul class="list-group list-group-flush">
                <li
                  v-for="(item, index) in results"
                  :key="item.id"
                  class="list-group-item d-flex justify-content-between align-items-center"
                  :class="{ 'bg-primary text-white': index === itemIndex }"
                  style="padding: 10px; font-size: 0.95rem; cursor: pointer;"
                >
                  <!-- Clickable Product Info -->
                  <div
                    class="flex-grow-1 d-flex flex-column"
                    @click="selectItem(item)"
                    style="cursor: pointer;"
                  >
                    <div class="d-flex align-items-center gap-2">

                      <!-- Item Info -->
                      <div class="d-flex flex-column">
                        <strong class="text-dark">{{ item.node }} - {{ item.account_id }}</strong>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>

              <!-- No Results -->
              <div v-if="!results.length" class="text-center text-muted py-4" style="font-size: 1rem;">
                No results found
              </div>
            </div>
            </div>
  	    </div>
  	    <!-- <div class="col-md-6"></div> -->

        <div class="col-md-4">
          <label class="form-label fw-semibold small text-secondary mb-1">
            <i class="bi bi-calendar3 me-1"></i>{{ $t('start_date') }}
          </label>
          <VueDatePicker 
            v-model="filters.start_date" 
            :formats="{ input: 'dd-MM-yyyy' }"
            model-type="yyyy-MM-dd"
            :time-config="{ enableTimePicker: false }"
            :ui="{ input: 'form-control shadow-sm rounded-pill' }"
            auto-apply
          />
          <div v-if="errors.start_date" class="text-danger small mt-1">
            <i class="bi bi-exclamation-circle"></i> {{ errors.start_date }}
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label fw-semibold small text-secondary mb-1">
            <i class="bi bi-calendar3 me-1"></i>{{ $t('end_date') }}
          </label>
          <VueDatePicker 
            v-model="filters.end_date" 
            :formats="{ input: 'dd-MM-yyyy' }"
            model-type="yyyy-MM-dd"
            :time-config="{ enableTimePicker: false }"
            :ui="{ input: 'form-control shadow-sm rounded-pill' }"
            auto-apply
          />
          <div v-if="errors.end_date" class="text-danger small mt-1">
            <i class="bi bi-exclamation-circle"></i> {{ errors.end_date }}
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="text-muted my-4" />

      <!-- Buttons -->
      <div class="row">
        <div class="col-3 d-flex mt-2 p-1">
            <button @click="submitLedgerReport" class="btn btn-outline-primary px-4 flex-fill">
              <i class="bi bi-arrow-repeat me-2"></i>  Ledger Report
            </button>
        </div>
        <div class="col-3 d-flex mt-2 p-1">
          <button @click="submitFinanceReport('trial')" class="btn btn-outline-primary px-4 flex-fill">
          <i class="bi bi-arrow-repeat me-2"></i>  Trial Balance Report
        </button> 
        </div>
        <div class="col-3 d-flex mt-2 p-1">
          <button @click="submitFinanceReport('income_expense')" class="btn btn-outline-primary px-4 flex-fill">
          <i class="bi bi-arrow-repeat me-2"></i>  Income & Expense Report
        </button>
        </div>
        <div class="col-3 d-flex mt-2 p-1">
          <button @click="submitFinanceReport('income_state')" class="btn btn-outline-primary px-4 flex-fill">
          <i class="bi bi-arrow-repeat me-2"></i>  Income Statement Report
        </button>
        </div>
        <div class="col-3 d-flex mt-2 p-1">
          <button @click="submitFinanceReport('balance')" class="btn btn-outline-primary px-4 flex-fill">
          <i class="bi bi-arrow-repeat me-2"></i>  Balance Sheet Report
        </button>
        </div>
        <div class="col-3 d-flex mt-2 p-1">
          <button @click="submitFinanceReport('equity')" class="btn btn-outline-primary px-4 flex-fill">
          <i class="bi bi-arrow-repeat me-2"></i>  Owner`s Equity Report
        </button>
        </div>
      </div>
      
    </div>

  </div>
</template>


<script>
import apiUrls from "@/urls";
import { useToast } from 'vue-toastification';
import feather from "../../../../public/assets/js/feather.min";
import debounce from 'lodash.debounce'
import dayjs from 'dayjs'

export default {
  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      filters: {
        start_date: "",
        end_date: new Date().toISOString().split('T')[0],
        account_id: "",
        flag:0,
      },
      errors: {},
      results:[],
      query:'',
      debouncedSearch:null,
      itemIndex:null,
      selectedItem:null,
      opening:null,
      opening_balance:0,
      ledgers:[],
      runing_balance:0,
    };
  },
  created() {
    this.debouncedSearch = debounce(this.searchItems, 300)
  },

  methods: {
    dateFormat(date){
      if(!date) return;
      return dayjs(date).format('DD-MM-YYYY')
    },

    async getHeadName(account_id) {
      const response = await this.$axios.get(apiUrls.chart_of_accounts.get, {
            params: {status:'Child' }
          })
        const head = response.data.find(item => item.account_id == account_id)
        return head ? head.node : ''
    },
  	selectItem(item) {
      console.log('SelectItem:::',item)
      this.selectedItem = item
      this.query = item.node
      this.filters.account_id = item.account_id
      this.results = []
      this.itemIndex = 0;
    },
  	async searchItems() {
        if (!this.query) {
          this.results = []
          return
        }

        try {
          const response = await this.$axios.get(apiUrls.chart_of_accounts.get, {
            params: {q: this.query, status:'Child' }
          })
          const results = response.data || [];
          this.results = results;
          this.itemIndex = 0;

          await this.$nextTick(() => {
            if (window.feather) feather.replace()
          })
        } catch (error) {
          console.error('Search error:', error)
          this.results = []
        }
      },
  	handleKeys(event) {
        if (event.key === 'ArrowDown') {
          this.itemIndex = Math.min(this.itemIndex + 1, this.results.length - 1);
          event.preventDefault();
        } else if (event.key === 'ArrowUp') {
          this.itemIndex = Math.max(this.itemIndex - 1, 0);
          event.preventDefault();
        } else if (event.key === 'Enter') {
          const selectedProduct = this.results[this.itemIndex];
          if (selectedProduct) {
            this.selectItem(selectedProduct);
          }
          event.preventDefault();
        }
      },
      async submitLedgerReport() {
        if(!this.filters.account_id || !this.filters.start_date || !this.filters.end_date){
          this.toast.warning("Empty field Not Allow!");
          return;
        } 
      	try {
	        const params = new URLSearchParams(this.filters).toString();

	        const response = await this.$axios.get(`${apiUrls.report_ledger.get}?${params}`, {responseType: 'blob'});

	        // Create a temporary link element
	        const link = document.createElement('a');
	        link.href = window.URL.createObjectURL(response.data);
	        link.download = 'ledger_report.pdf';

	        // Trigger the download
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);

	        // this.toast.success("Ledger report successfully downloaded!");
	        this.$emit("create_success");
	        // this.resetForm()

      	} catch (error) {
          console.log(error)
        }
      },
      async submitFinanceReport(types) {
        if(!this.filters.start_date || !this.filters.end_date){
          this.toast.warning("Date field is not empty!");
           return;
        }
      	try {
          if(types == 'income_state' || types == 'balance'){
            this.filters.flag = 1
          }else{
            this.filters.flag = 0
          }
	        const params = new URLSearchParams(this.filters).toString();
          // Create a temporary link element
          const link = document.createElement('a');

          if(types == 'trial'){
            const response = await this.$axios.get(`${apiUrls.report_trial_balance.get}?${params}`, {responseType: 'blob'});
            link.href = window.URL.createObjectURL(response.data);
            link.download = 'trial_balance.pdf';
          }else if(types == 'income_expense'){
            const response = await this.$axios.get(`${apiUrls.report_income_expense.get}?${params}`, {responseType: 'blob'});
            link.href = window.URL.createObjectURL(response.data);
            link.download = 'income_expense.pdf';
          }else if(types == 'income_state'){
            const response = await this.$axios.get(`${apiUrls.report_income_expense.get}?${params}`, {responseType: 'blob'});
            link.href = window.URL.createObjectURL(response.data);
            link.download = 'income_statement.pdf';
          }else if(types == 'balance'){
            const response = await this.$axios.get(`${apiUrls.report_balance_sheet.get}?${params}`, {responseType: 'blob'});
            link.href = window.URL.createObjectURL(response.data);
            link.download = 'balance_sheet.pdf';
          }else if(types == 'equity'){
            const response = await this.$axios.get(`${apiUrls.report_balance_sheet.get}?${params}`, {responseType: 'blob'});
            link.href = window.URL.createObjectURL(response.data);
            link.download = 'owner_equity.pdf';
          }
	        

	        // Trigger the download
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);

	        // this.toast.success("Trial Balance report successfully downloaded!");
	        this.$emit("create_success");
	        // this.resetForm()

      	} catch (error) {
          console.log(error)
        }
      },
    resetForm() {
      this.filters = {
        start_date: "",
        end_date: new Date().toISOString().split('T')[0],
        account_id: "",
        flag:0,
      };
      this.errors = {};
      this.query='';
    },
  }
}

</script>

<style scoped>
caption{
  font-size:18px !important;
}
</style>